import { Check } from 'lucide-react';

export type NodeState = 'complete' | 'done' | 'active' | 'pending';

// Pipeline stage node (DC §7.1). The 4px var(--background) ring makes the
// connector read as passing behind the circle.
export function PipelineNode({
  num,
  accent,
  state,
}: {
  num: string;
  accent: string;
  state: NodeState;
}) {
  let bg = 'var(--card)';
  let border = accent;
  let color = accent;
  let content: React.ReactNode = num;
  let pulse = false;

  if (state === 'done') {
    bg = accent;
    border = accent;
    color = '#fff';
    content = <Check style={{ width: 15, height: 15 }} />;
  } else if (state === 'active') {
    bg = 'var(--card)';
    border = 'var(--signal-blue)';
    color = 'var(--signal-blue)';
    pulse = true;
  } else if (state === 'pending') {
    bg = 'var(--muted)';
    border = 'var(--border)';
    color = 'var(--muted-foreground)';
  }

  return (
    <div
      style={{
        position: 'relative',
        zIndex: 1,
        flexShrink: 0,
        width: 44,
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 14,
      }}
    >
      <span
        className={pulse ? 'animate-pulse' : undefined}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          borderRadius: 99,
          background: bg,
          border: `2px solid ${border}`,
          color,
          fontSize: 13,
          fontWeight: 700,
          boxShadow: '0 0 0 4px var(--background)',
        }}
      >
        {content}
      </span>
    </div>
  );
}
